import VettingList from './VettingList'
import VettingSingle from './VettingSingle'
import VettingEdit from './VettingEdit'
import VettingDuplicate from './VettingDuplicate'

export default {
  VettingList,
  VettingSingle,
  VettingEdit,
  VettingDuplicate
}
